import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nqrmgm-navigaion',
  templateUrl: './nqrmgm-navigaion.component.html',
  styleUrls: ['./nqrmgm-navigaion.component.scss']
})
export class NqrmgmNavigaionComponent implements OnInit {
  qrresp: any;
  qrCodeValue: any;
  isLoading = false;
  constructor(private router: Router, private http: HttpClient, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const qrrespUrl = "https://myfoodgenie.com/nfmgenieapi/qrcdetails/getAllQRCDetails";
    this.http.get(qrrespUrl).subscribe(
      (response: any) => {
        this.qrresp = response.qrcdetailsList;
        console.log('API Response:', this.qrresp);
  
        // Extract ID from the route and call onScanSuccess
        this.route.paramMap.subscribe(params => {
          const id = params.get('id');
    
          // Do something with the ID (e.g., navigate, fetch data, etc.)
          if (id) {
            // Call onScanSuccess only when qrresp is populated
            this.onScanSuccess(id);
          }
        });
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
   
  }
  startLoading() {
    this.isLoading = true;

    // Simulate an asynchronous operation
    setTimeout(() => {
      // After some operation is complete, stop the loading
      this.stopLoading();
    }, 5000);
  }

  stopLoading() {
    this.isLoading = false;
  }
  async onScanSuccess(qrId: any){
    this.startLoading();
    console.log(qrId);
    
    this.qrCodeValue=this.qrresp.find((obj) => obj.qrId === qrId);
    
 
      const urlToNavigate = this.qrCodeValue.value;
      const urlParts = urlToNavigate.split('#');
      if (urlParts.length === 2) {
        // The second part of the split array contains the values after '#'
        const fragment = urlParts[1];
    
        // Now you can use the fragment value (e.g., navigate to it)
        
        this.router.navigateByUrl(fragment);
      }
      // this.router.navigate()
      // window.location.href =  urlToNavigate;
 
    else {
      console.log('No matching object found for qrId:', qrId);
    }
  
    
    // else{
    //   (error) => {
    //     console.error('Error fetching data:', error);
    //   };
    // }
   
  // if(qrCodeValue){
   
  //   const matchedQr = this.qrresp.find((item: any) => item.qrId === qrCodeValue);
  
  //   if (matchedQr) {
    
        
  //     window.location.href= matchedQr.value ;
      
  //   } else {
      
  //     console.error('QR Code not recognized');
  //   }
  // }
   // this.modalReference.close();
    // let lastSegment="";
    // if(qrresult.includes("GEN_")){
    //   const parts = qrresult.split("#");
    //   if(parts.length>1){
    //     console.log(parts[1]);
    //     this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //       return false;
    //   }
    //   this.router.onSameUrlNavigation = 'reload';
    //     this.router.navigate([`${parts[1]}`],{replaceUrl:true});
    //   }
    // }
    // if(qrresult.includes("SLT_")){
    //   const parts = qrresult.split("#");
    //   if(parts.length>1){
    //     console.log(parts[1]);
    //     this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //       return false;
    //   }
    //   this.router.onSameUrlNavigation = 'reload';
    //     this.router.navigate([`${parts[1]}`],{replaceUrl:true});
    //   }
    // }
    // if(!qrresult.includes("GEN_") && !qrresult.includes("SLT_")){
    //   const machIdOrDisplayId= qrresult;
    //   const machineObj = this.machinesList.find(obj=> obj.stallid==parseInt(machIdOrDisplayId) || obj.vmsMachId==machIdOrDisplayId);
    //   if(machineObj){
    //    this.dataService.setMachineId(machineObj.stallid);
    //    localStorage.setItem("genieName", machineObj.name);
    //    localStorage.setItem('genieId', machineObj.stallid+"");
    //    this.dataService.UpdateGenieName(machineObj.name);
    //    // temporary
    //    //  this.dataService.setIsSearchDisable(true);
      
    //   }
     
    // }
    
  }
}
